import { ProductType } from '../Application/ProductType';

export interface GetProductsByTypeQuery {
  type?: ProductType;
}
